module.exports = __webpack_public_path__ + "static/investmentsBox-e86c26e70a150924677d40004cb84722.png";